import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { getLocalUrl } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  getApiUrl(forceHttps = false): string {
    const {origin, hostname, protocol} = this.document.location;
    if (origin.includes('localhost')) {
      // LOCAL
      return getLocalUrl();
    } else {
      if (forceHttps) {
        return 'https://' + hostname + '/';
      }
      return (
        protocol + '//' + hostname + '/'
      );
    }
  }
}
